/**
 * Shared auth state to coordinate logout across MSAL event handlers and the
 * token-refresh interceptor.  Only the first caller wins; subsequent calls are
 * no-ops, preventing overlapping logoutRedirect attempts.
 */
let isLoggingOut = false;

export const beginLogout = () => {
    if (isLoggingOut) return false;
    isLoggingOut = true;
    return true;
};
